import BASEURLGESTTOR from '../api/gesttor'
import { payloadCadastrarModulo, payloadAtualizarModulo } from '../../interfaces/modulos'

export function cadastrarModulo(payload: payloadCadastrarModulo) {
  return BASEURLGESTTOR.post('/modulos', payload)
}

export function atualizarModulo(idModulo: string, payload: payloadAtualizarModulo) {
  return BASEURLGESTTOR.patch(`/modulos/${idModulo}`, payload)
}

export function buscarModulos(idOrganizacao: string) {
  return BASEURLGESTTOR.get(`/modulos/${idOrganizacao}`)
}

export function buscarModulosAtivos(idOrganizacaoEmpresa: string) {
  return BASEURLGESTTOR.get(`/modulosAtivos/${idOrganizacaoEmpresa}`)
}

export function buscarSaldos(idOrganizacaoEmpresa: string) {
  return BASEURLGESTTOR.get(`/saldoDoc/${idOrganizacaoEmpresa}`)
} 